










































import { Component, Vue, Watch } from 'vue-property-decorator';
import { BffSettings } from '@/api/bff';
import { Models } from '@mtap-smartcity/api';

type DeviceTab = 'lamp' | 'gateway';

interface AvailableField {
  key: string;
  label: string;
}

@Component({})
export default class DeviceHintsTab extends Vue {
  selectedTab: DeviceTab = 'lamp';

  loading = false;

  error: string | null = null;

  changes = false;

  selectedHints: string[] = [];

  deviceDetailsFields: Models.Devices.DeviceDetailField[] = [];

  availableFixedKeys = {
    lamp: [
      'gateway',
      'address',
      'model',
      'producer',
      'maxPower',
      'luminousEfficiency'
    ],
    gateway: [
      // No specific fixed fields for gateway yet, but can add
    ],
  };

  get tabs() {
    return [
      { name: this.$tc('main.lamp', 2), value: 'lamp' },
      { name: this.$tc('main.gateway', 2), value: 'gateway' },
    ];
  }

  get allFields(): AvailableField[] {
    const fixedKeys = this.availableFixedKeys[this.selectedTab] || [];
    const fixed = (fixedKeys as string[]).map((key) => ({
      key,
      label: this.getFieldLabel(key)
    }));
    const dynamic = this.deviceDetailsFields.map((field) => ({
      key: field.name,
      label: field.name
    }));
    return fixed.concat(dynamic);
  }

  getFieldLabel(key: string): string {
    const translationMap = {
      gateway: this.$tc('deviceParameters.gateway', 1),
      address: this.$tc('deviceParameters.address', 1),
      model: this.$tc('deviceParameters.model', 1),
      producer: this.$tc('deviceParameters.producer', 1),
      maxPower: this.$tc('deviceParameters.maxPower', 1),
      luminousEfficiency: this.$tc('deviceParameters.luminousEfficiency', 1),
    };
    return translationMap[key] || key;
  }

  updateSelectedTab(newTab: DeviceTab) {
    this.selectedTab = newTab;
  }

  isFieldSelected(fieldKey: string): boolean {
    return this.selectedHints.includes(fieldKey);
  }

  refreshPage() {
    window.location.reload();
  }

  @Watch('selectedTab')
  async onTabChange() {
    await this.fetchData();
  }

  async fetchData() {
    try {
      this.loading = true;
      this.error = null;

      // Fetch selected hints for display
      const selectedHintsResponse = await BffSettings.getDeviceHints(this.selectedTab);
      this.selectedHints = selectedHintsResponse.map((field) => field.name);

      // Fetch deviceDetails fields for availability
      const deviceDetails = await BffSettings.getDeviceDetailsSettings(this.selectedTab);
      this.deviceDetailsFields = deviceDetails;
    } catch (err) {
      this.error = err instanceof Error ? err.message : 'Failed to load fields';
      console.error('Failed to fetch data:', err);
    } finally {
      this.loading = false;
    }
  }

  async toggleFieldSelection(fieldKey: string) {
    const isSelected = this.isFieldSelected(fieldKey);
    try {
      if (isSelected) {
        // Remove from hints
        await BffSettings.removeDeviceHintsField(this.selectedTab, fieldKey);
        this.selectedHints = this.selectedHints.filter((key) => key !== fieldKey);
      } else {
        // Add to hints
        const field: Models.Devices.DeviceDetailField = {
          name: fieldKey,
          type: 'text',
          deprecated: false,
          renamed_to: null
        };
        await BffSettings.addDeviceHintsField(this.selectedTab, field);
        this.selectedHints.push(fieldKey);
      }
    } catch (err) {
      console.error('Failed to update hint selection:', err);
      // Optionally show user error
    } finally {
      this.changes = true;
    }
  }

  // Initialize data on mount
  async mounted() {
    await this.fetchData();
  }
}
